import { InMemoryCache } from 'apollo-cache-inmemory';
import { /*CachePersistor, */persistCache } from 'apollo-cache-persist';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { RetryLink } from "apollo-link-retry";
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import UpdateAlert from './graphql/UpdateAlert.gql';
// import UpdateErrors from './graphql/UpdateErrors.gql';

Vue.use(VueApollo);

const cache = new InMemoryCache();

// const persistor = new CachePersistor({
//   cache,
//   storage: window.localStorage
// });

// persistor.restore();

// (async (persistor) => {
//   try {
//     // Might throw Couldn't read row 0, col 0 from CursorWindow
//     await persistor.restore();
//   } catch (error) {
//     // CachePersistor failed - purge
//     // await persistor.purge();
//     console.error('Error restoring Apollo cache', error);
//   }
// });

persistCache({
  cache,
  storage: window.localStorage
});

// (async () => {
//   try {
//     // See above for additional options, including other storage providers.
//     await persistCache({
//       cache,
//       storage: window.localStorage
//     });
//   } catch(error) {
//     console.error('Error restoring Apollo cache', error);
//   }
// });

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_GRAPHQL_HTTP_SERVER_URI
});

const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true
  },
  attempts: {
    max: 5,
    retryIf: (error, /*_operation*/) => !!error
  }
});

const authLink = setContext((_, { headers }) => {
  let token = JSON.parse(localStorage.getItem('auth-token'));
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token.accessToken}` : ''
    }
  }
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
    });
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
    let apolloClient = apolloProvider.defaultClient;
    apolloClient.mutate({
      mutation: UpdateAlert,
      variables: {
        message: `[Network error]: ${networkError}`,
        variant: 'danger'
      }
    });
  }
});

// const errorLink = onError(({ graphQLErrors, networkError }) => {
//   let apolloClient = apolloProvider.defaultClient;
//   if (graphQLErrors) {
//     graphQLErrors.map(({ message, locations, path, extensions }) => {
//       console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
//       let input = [];
//       if (extensions.code === 'BAD_USER_INPUT') {
//         extensions.exception.invalidArgs.map(error => {
//           input.push(error.title);
//         });
//       }

//       apolloClient.mutate({
//         mutation: UpdateErrors,
//         variables: {
//           input
//         }
//       });
//     });
//   }

//   if (networkError) {
//     console.log(`[Network error]: ${networkError}`);
//     apolloClient.mutate({
//       mutation: UpdateAlert,
//       variables: {
//         message: `[Network error]: ${networkError}`,
//         variant: 'danger'
//       }
//     });
//   }
// });

const resolvers = {
  Mutation: {
    updateAlert: (_, { message = '', variant = 'success', show = true }, { cache }) => {
      let data = {
        alert: {
          __typename: 'Alert',
          message,
          variant,
          show
        }
      }
      cache.writeData({ data });
      // return null;
      return data.alert;
    },
    updateErrors: (_, { input = [] }, { cache }) => {
      let errors = []
      input.forEach(error => {
        errors.push({
          __typename: 'Error',
          message: error
        });
      })
      let data = {
        errors
      }
      cache.writeData({ data });
      return null;
    },
    // updateToken: (_, { token = null }, { cache }) => {
    //   let data = {
    //     token: {
    //       __typename: 'Token',
    //       token: token
    //     }
    //   }
    //   cache.writeData({ data });
    //   return data.token;
    // }
  }
}

const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    authLink,
    retryLink,
    httpLink
  ]),
  cache,
  connectToDevTools: true,
  resolvers
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: 'loading'
  }
});

const clearStore = async () => {
  try {
    await apolloProvider.defaultClient.clearStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

export { apolloProvider, clearStore/*, persistor*/ };
